/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [

  // Login deskDaf
  {
    path: '/login-deskdaf',
    name: 'loginDeskDaf.index',
    component: () => import('@/pages/LoginDeskDaf/Index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },

  // Login
  // Login EdocSign
  {
    path: '/login-edocSign',
    name: 'loginEdocSign.index',
    component: () => import('@/pages/LoginEdocSign/Index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },

  // Display user page
  {
    path: '/users',
    name: 'users.index',
    component: () => import('@/pages/Users/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },
  {
    path: '/users/:userId',
    name: 'users.ListPerimeters.index',
    component: () => import('@/pages/Users/ListPerimeters/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Display configuration perimeters
  {
    path: '/perimeters',
    name: 'perimeters',
    component: () => import('@/pages/Perimeters/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Display page for creating perimeters

  {
    path: '/perimeters/create',
    name: 'perimeters.create',
    component: () => import('@/pages/Perimeters/CreatePerimeter.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Display options of a selected perimeter
  {
    path: '/perimeters/:perimetersId',
    name: 'perimeters.options',
    component: () => import('@/pages/Perimeters/Options/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Display users from a selected perimeter
  {
    path: '/perimeters/:perimetersId/utilisateurs',
    name: 'perimeters.options.utilisateurs',
    component: () => import('@/pages/Perimeters/Options/Utilisateurs/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Page used to assign a user to a perimeter
  {
    path: '/perimeters/:perimetersId/utilisateurs/AssignUser',
    name: 'perimeters.options.utilisateurs.assign',
    component: () => import('@/pages/Perimeters/Options/Utilisateurs/AssignUser.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  // Login DeskRh
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/pages/Login/Index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },

  // Organizations
  {
    path: '/organizations',
    name: 'organizations.index',
    component: () => import('@/pages/Organizations/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/organizations/create',
    name: 'organizations.create',
    component: () => import('@/pages/Organizations/Create.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/organizations/:organizationId',
    name: 'organizations.show',
    component: () => import('@/pages/Organizations/Show.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },
  // Domain groups
  {
    path: '/domain-groups',
    name: 'domainGroups.index',
    component: () => import('@/pages/DomainGroups/Index.vue'),

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },

  {
    path: '/domain-groups/:domainGroupId',
    name: 'domainGroups.show',
    component: () => import('@/pages/DomainGroups/Show.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      authEdocSign: true,
    },
  },
  // FileTypes
  {
    path: '/organizations/:organizationId/file-types',
    name: 'organizations.file-types.index',
    component: () => import('@/pages/Organizations/FileTypes/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/organizations/:organizationId/file-types/create',
    name: 'organizations.file-types.create',
    component: () => import('@/pages/Organizations/FileTypes/Create.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  // Parsers
  {
    path: '/organizations/:organizationId/parsers',
    name: 'organizations.parsers.index',
    component: () => import('@/pages/Organizations/Parsers/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },
  {
    path: '/organizations/:organizationId/parsers/create',
    name: 'organizations.parsers.create',
    component: () => import('@/pages/Organizations/Parsers/Create.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  // SubscribedServices
  {
    path: '/organizations/:organizationId/subscribed-services',
    name: 'organizations.subscribed-services.index',
    component: () => import('@/pages/Organizations/SubscribedServices/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  // Sign Workflow
  {
    path: '/organizations/:organizationId/sign-workflow',
    name: 'organizations.sign-workflow.index',
    component: () => import('@/pages/Organizations/SignWorkflow/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  // Publishing
  {
    path: '/organizations/:organizationId/publishing',
    name: 'organizations.publishing.index',
    component: () => import('@/pages/Organizations/Publishing/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  // SAE
  {
    path: '/organizations/:organizationId/sae',
    name: 'organizations.sae.index',
    component: () => import('@/pages/Organizations/SAE/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },

  {
    path: '/sae-config',
    name: 'sae-config.index',
    component: () => import('@/pages/Sae/Index.vue'),
    props: true,

    // If the user needs to be authenticated to view this page.
    meta: {
      auth: true,
    },
  },


  {
    path: '/',
    redirect: '/organizations',
  },

  {
    path: '/*',
    redirect: '/organizations',
  },
];



// WEBPACK FOOTER //
// ./src/routes/index.js